// extracted by mini-css-extract-plugin
module.exports = {"container":"PS","links":"QS"};